import { AWFMenu } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../../contributions.enum';
import { DriveCycleTableDeleteMenuItem } from './drive-cycle-table-delete.menu-item';

@AWFMenu({
  id: ContributionsEnum.DRIVE_CYCLE_MENU_ID,
  items: [DriveCycleTableDeleteMenuItem],
})
export class DriveCycleTableMoreMenu {}
